export const MAX_TEXT_FIELD_LENGTH = 25
